import surfaceStore from '../store/surfaceStore';
import { getNextDateRange } from 'owa-datetime-utils';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import dateRangeToDisplayString from 'owa-timestrip/lib/utils/dateRangeToDisplayString';

export function getNextSurfaceDateRange() {
    const currentDateRange = surfaceStore.dateRange;
    const currentDateRangeType = surfaceStore.dateRangeType;
    return getNextDateRange(currentDateRange, currentDateRangeType);
}

export function getNextSurfaceDateRangeString() {
    const userOptions = getUserConfiguration().UserOptions;
    return dateRangeToDisplayString(
        getNextSurfaceDateRange(),
        surfaceStore.dateRangeType,
        userOptions.WeekStartDay,
        userOptions.ShowWeekNumbers,
        userOptions.FirstWeekOfYear as any,
        false
    );
}
